import { removeEmpty } from '@/utils/tools'

export default (obj) => {
  if (obj.id) return obj.id
  return removeEmpty(
    Object.keys(obj).map((key) =>
      // eslint-disable-next-line no-nested-ternary
      typeof obj[key] === 'boolean' ? (obj[key] ? `${key}` : '') : `${key}|${obj[key]}`,
    ),
  ).join(',')
}
